var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photovoltaicDevOps mainPageBg"},[_c('DevOpsPublicCom',{attrs:{"system":'光伏系统'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }